import Reveal from '@/components/feature/Reveal';
import { heroCards, heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pb-16 pt-28 md:pb-24 md:pt-36">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(60% 55% at 50% 0%, oklch(var(--primary-100) / 0.75) 0%, oklch(var(--background-50) / 0) 70%)',
        }}
      />
      <div className="paper-grain pointer-events-none absolute inset-0 opacity-60" />

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 font-label text-xs tracking-wide text-primary-700">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-radar-line text-sm" />
              </span>
              资讯聚合 · 分类导航 · 持续收录
            </span>
          </Reveal>

          <Reveal delay={80}>
            <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
              黑料导航
            </h1>
          </Reveal>

          <Reveal delay={140}>
            <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              把散落在网络各处的吃瓜站点，整理成一份看得懂的
              <strong className="mx-1 font-semibold text-foreground-900">黑料导航分类</strong>
              目录。顺着分类一层层往下走，或在
              <strong className="mx-1 font-semibold text-foreground-900">黑料导航资源</strong>
              合集里直接进入想看的方向，长期更新的
              <strong className="mx-1 font-semibold text-foreground-900">黑料导航网站大全</strong>
              都在这里。
            </p>
          </Reveal>
        </div>

        <Reveal delay={200} className="mt-12 md:mt-16">
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
            {heroCards.map((card) => (
              <a
                key={card.id}
                href="#categories"
                className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
              >
                <span className="font-display text-2xl font-black text-primary-400 transition-colors group-hover:text-primary-600 md:text-3xl">
                  {card.index}
                </span>
                <span className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {card.title}
                </span>
                <span className="mt-1 font-label text-xs text-foreground-500">{card.count}</span>
                <span className="mt-3 hidden text-xs leading-6 text-foreground-600 md:block">
                  {card.desc}
                </span>
                <span className="mt-4 flex flex-wrap gap-1.5">
                  {card.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </span>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={260} className="mt-10 md:mt-14">
          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="bg-background-50 px-4 py-5 text-center md:py-6">
                <p className="font-display text-2xl font-black text-foreground-950 md:text-3xl">
                  {stat.value}
                </p>
                <p className="mt-1 font-label text-xs tracking-wide text-foreground-500">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}